// import {Handler} from "express";

export interface Route {
  path: string
  type: RouteType | string
  handler: Array<any | string>
  acl: {
    [key: string]: boolean
  }
  disabled?: boolean
}

export enum RouteType {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  PATCH = 'patch',
  DELETE = 'delete',
  HEAD = 'head',
  OPTIONS = 'options'
}
